// A client's CRM tracks + the shared contacts they point at, for the meeting's "Contacts &
// outreach" block (CRM spec 2026-11-03). Never throws: a failed load means "no block" (null),
// so a CRM outage can't stop a meeting from opening, presenting or sending.
import { useEffect, useState } from "react";
import { api } from "../api/client.js";

export async function loadCrmData(clientId) {
  if (!clientId) return null;
  try {
    const [tracks, contacts] = await Promise.all([api.crmTracks.listAll({ clientId }), api.contacts.listAll()]);
    return tracks && contacts ? { tracks, contacts } : null;
  } catch {
    return null;
  }
}

export function useCrmData(clientId) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let cancelled = false;
    loadCrmData(clientId).then((d) => { if (!cancelled) setData(d); });
    return () => { cancelled = true; };
  }, [clientId]);
  return data;
}
